<template>
  <div v-if="post">
    <h2 class="mt-8 text-sm font-bold uppercase tracking-wide">
      Latest blog post
    </h2>
    <NuxtLink
      :to="`/${post.slug}`"
      class="mt-4 block border-2 border-border bg-white p-4"
      data-testid="latest-blog-post"
      @click="useTrackEvent('sidebarLatestBlogClick')"
    >
      <div v-if="post.image" class="mb-3">
        <Image :src="post.image" :alt="post.title" />
      </div>
      <h3 class="text-lg font-bold leading-tight">
        {{ post.title }}
      </h3>
      <span class="mt-3 inline-flex items-center gap-2 text-sm font-bold uppercase">
        Read post <span>&rarr;</span>
      </span>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { BlogPost } from '~/types/blog';


const { data: blogData } = await useAsyncData('latestBlog', () =>
  queryContent<BlogPost>('/').where({ published: true }).sort({ date: -1 }).find()
)

const route = useRoute()
const currentSlug = route.params.slug[0]

const post = computed(() => {
  if (blogData.value?.[0].slug === currentSlug) return blogData.value?.[1]
  return blogData.value?.[0] || null
})
</script>
